(function (window, document) {
  'use strict';

  function WorkLightbox(options) {
    this.gallerySelector = options.gallerySelector;
    this.itemSelector = options.itemSelector;
    this.gallery = document.querySelector(this.gallerySelector);
    this.items = this.gallery ? this.gallery.querySelectorAll(this.itemSelector) : [];
    this.instance = null;
  }

  WorkLightbox.prototype.canInit = function () {
    return (
      !!this.gallery &&
      this.items.length > 0 &&
      typeof window.PhotoSwipeLightbox !== 'undefined' &&
      typeof window.PhotoSwipe !== 'undefined'
    );
  };

  WorkLightbox.prototype.getOptions = function () {
    return {
      gallery: this.gallery,
      children: this.itemSelector,
      pswpModule: window.PhotoSwipe,
      arrowPrev: true,
      arrowNext: true,
      close: false,
      counter: false,
      zoom: false,
      bgOpacity: 0.8,
      loop: this.items.length > 2,
      showAnimationDuration: 250,
      hideAnimationDuration: 250,
      zoomAnimationDuration: 0,
      initialZoomLevel: 'fit',
      secondaryZoomLevel: 1,
      maxZoomLevel: 1,
      wheelToZoom: false,
      pinchToClose: true,
      closeOnVerticalDrag: true,
      imageClickAction: 'close',
      tapAction: 'close',
      bgClickAction: 'close',
      preloaderDelay: 999999,
    };
  };

  WorkLightbox.prototype.init = function () {
    if (!this.canInit()) {
      return;
    }

    this.instance = new window.PhotoSwipeLightbox(this.getOptions());
    this.instance.init();
  };

  function initWorkLightbox() {
    var lightbox;

    lightbox = new WorkLightbox({
      gallerySelector: '[data-work-masonry]',
      itemSelector: '.work-masonry-item',
    });

    lightbox.init();
  }

  window.addEventListener('load', initWorkLightbox);
})(window, document);
